export default {"src":"/_next/static/media/credit.92e9ddf2.svg","height":261,"width":280,"blurWidth":0,"blurHeight":0};